<template lang="pug">
.page-top-area.fixed-top
.q-mb-lg.q-pb-xl
    header-mobile.search-header(
        :searchPlaceholder="route.query.query"
        :showHumburg="false")
    .row.full-width.justify-between.q-px-md.q-py-sm(:class="fixFilters ? 'fixed' : ''")
        .col-3
            q-icon(
                name="etabl:arrow_prev"
                size="18px"
                color="positive"
                @click="searchExit"
            )
        sorting-mobile.col-grow
        .row.col-3.justify-end
            q-icon.q-mr-md(
                size="25px"
                color="positive"
                :name="isVertical ? 'etabl:list' : 'etabl:blocks'"
                @click="isVertical = !isVertical")
            filters-mobile(:propFilters="filters")
    .q-mx-md.q-py-sm(v-if="searchRegions")
        base-btn(
            label="Найти в другом регионе"
            height="36"
            bradius="16"
            @click="showAnotherCities = true"
        )
    product-list-mobile(
        :class="fixFilters ? 'q-mt-xl' : ''"
        :propProducts="newProducts"
        :isVertical="isVertical"
        :propLoading="loading")
base-button-top-mobile
another-cityes-mobile(
    :regions="searchRegions"
    :showAnotherCities="showAnotherCities"
    @hideCities="hideCities"
)
</template>

<script>
import { scroll } from 'quasar';
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import HeaderMobile from 'components/Header/HeaderMobile.vue';
import FiltersMobile from 'components/Filters/FiltersMobile.vue';
import BaseButtonTopMobile from 'components/Base/BaseButtonTopMobile.vue';
import ProductListMobile from 'components/ProductList/ProductListMobile.vue';
import SortingMobile from 'components/Sorting/SortingMobile.vue';
import BaseBtn from 'src/components/Base/BaseBtn.vue';
import AnotherCityesMobile from 'src/components/Search/AnotherCityesMobile.vue';

const { getScrollTarget, setVerticalScrollPosition } = scroll;


export default {
    name: 'SearchMobile',
    components: {
        HeaderMobile,
        FiltersMobile,
        ProductListMobile,
        BaseButtonTopMobile,
        SortingMobile,
        BaseBtn,
        AnotherCityesMobile,
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const isVertical = ref(false);
        const fixFilters = ref(false);
        const showAnotherCities = ref(false);
        
        // фильтры
        const filters = computed(() => store.getters['search/SEARCH_FILTERS_NEW']);

        // состояние загрузки
        const loading = computed(() => store.getters['search/LOADING']);

        // продукты
        const products = computed(() => store.getters['search/SEARCH_PRODUCTS']);

        const searchRegions = computed(() => store.getters['search/SEARCH_REGIONS']);

        const headerHeight = computed(() => {
            return process.env.CLIENT
                ? document.querySelector('.header')?.offsetHeight
                : 0;
        });
        
        const goScroll = () => {
            if (process.env.CLIENT) {
                if (pageYOffset > headerHeight.value + 8) {
                    if (fixFilters.value === false) {
                        fixFilters.value = true;
                    }
                } else {
                    if (fixFilters.value === true) {
                        fixFilters.value = false;
                    }
                }
            }
        };

        const newProducts = computed(() => store.getters['search/SEARCH_RESULT_NEW']);

        const previousRoute = computed(() => store.getters['search/SEARCH_EXIT_ROUTE']);

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const searchExit = () => {
            router.push(previousRoute.value);
        };

        const hideCities = () => {
            showAnotherCities.value = false;
        };

        onMounted(async () => {
            if (process.env.CLIENT) {
                window.addEventListener('scroll', goScroll);
            }
        });

        return {
            route,
            loading,
            filters,
            products,
            isVertical,
            goScroll,
            fixFilters,
            newProducts,
            previousRoute,
            searchExit,
            city,
            searchRegions,
            showAnotherCities,
            hideCities,
        };
    },
};
</script>

<style lang="scss" scoped>
.search-header {
    padding-top: calc(8px + constant(safe-area-inset-top)) !important;
    padding-top: calc(8px + env(safe-area-inset-top)) !important;
}

.fixed {
    background-color: #fbfafa;
    z-index: 2;
    top: 0;
}
</style>
